module.exports = __webpack_public_path__ + "img/FIAT-Betim.85cf774c.png";